export const MICROFRONTEND_NAME = 'underground-map-frontend';
